module.exports = __webpack_public_path__ + "img/show_card.f4272e77.svg";